export const orderStatus = {
  delivery: [
    {
      color: '#FFD952',
      icon: 'cart',
      label: 'Pending',
      name: 'PENDING',
    },
    {
      color: '#56afea',
      icon: 'car',
      label: 'Processing',
      name: 'APPROVED',
    },
    {
      color: '#2b5cb0',
      icon: 'arrived-icon',
      label: 'Started',
      name: 'DELIVERY_STARTED', // ASSIGNED
    },
  ],
  pickup: [
    {
      color: '#FFD952',
      icon: 'cart',
      label: 'Pending',
      name: 'PENDING',
    },
    {
      color: '#03c004',
      icon: 'ready-icon',
      label: 'Ready',
      name: 'APPROVED',
    },
  ],
};

export const orderLastStatus = [
  {
    color: '#03c004',
    default: true,
    icon: 'home',
    label: 'Completed',
    name: 'DELIVERED',
    tab: 6,
  },
  {
    color: '#E63E3E',
    default: false,
    icon: 'close',
    label: 'Declined',
    name: 'DECLINED',
    tab: null,
  },
  {
    color: '#bd68cc',
    default: false,
    icon: 'close',
    label: 'Refunded',
    name: 'REFUNDED',
    tab: null,
  },
];
